/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineSharedClassRooms200,
  GetApiV1ClassroomdisciplineSharedClassRooms401,
  GetApiV1ClassroomdisciplineSharedClassRoomsQueryParams,
  GetApiV1ClassroomdisciplineSharedClassRoomsQueryResponse,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedClassRooms.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1ClassroomdisciplineSharedClassRoomsQueryParamsSchema = z
  .object({
    Search: z.optional(z.string()),
    Take: z.optional(z.coerce.number().int()),
    Culture: z.optional(z.string()),
    CourseId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1ClassroomdisciplineSharedClassRoomsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineSharedClassRooms200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedClassRooms200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineSharedClassRooms401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineSharedClassRooms401>;

export const getApiV1ClassroomdisciplineSharedClassRoomsQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineSharedClassRooms200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedClassRoomsQueryResponse>;
